import React, { useEffect, useState } from 'react';
import qs from 'query-string';
import { useLocation, useNavigate } from '@reach/router';

import bridge from '~/utils/pro-bridge';
import dabangBridge from '~/utils/bridge';

import { Wrap } from './styled';

function TestComponent() {
  const [authKey, setAuthKey] = useState('');
  const [platform, setPlatform] = useState('');
  const [appVersion, setAppVersion] = useState('');
  const location = useLocation();
  const { pathname, search } = location;
  const parse = qs.parse(search);

  const navigate = useNavigate();

  useEffect(() => {
    setAuthKey(parse?.auth_key ?? '');
    setPlatform(parse?.platform ?? '');
    setAppVersion(parse?.version ?? '');
    navigate(pathname, { replace: true });
  }, []);

  function checkWebkitWindow() {
    window && window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.finishActivity.postMessage('');
  }

  function checkWebkit() {
    dabangBridge.iosWebkit(webkit => {
      webkit.messageHandlers.finishActivity.postMessage('');
    });
  }

  function close() {
    bridge.android(call => {
      call.finishActivity();
    });

    dabangBridge.ios(call => {
      call.callHandler('ObjC Echo', {
        cmd: 'finishActivity',
      });
    });
  }

  function openBrowser() {
    const url = 'https://naver.com';

    bridge.android(call => {
      console.log('android');
      call.openBrowser(url);
    });

    dabangBridge.ios(call => {
      call.callHandler('ObjC Echo', {
        cmd: 'openBrowser',
        url: url,
      });
    });
  }

  function loginReload() {
    console.log(authKey);

    dabangBridge.ios(call => {
      call.callHandler('ObjC Echo', {
        cmd: 'showLoginAndReload',
      });
    });

    bridge.android(call => {
      console.log('android');
      call.showLoginAndReload();
    });
  }

  function authReload() {
    dabangBridge.ios(call => {
      call.callHandler('ObjC Echo', {
        cmd: 'showAuthAndReload',
      });
    });

    bridge.android(call => {
      console.log('android');
      call.showAuthAndReload();
    });
  }
  
  function successSign() {
    dabangBridge.ios(call => {
      call.callHandler('ObjC Echo', {
        cmd: 'successSign',
      });
    });

    bridge.android(call => {
      console.log('android');
      call.successSign();
    });
  }

  function proClose() {
    bridge.android(call => {
      call.finishActivity();
    });

    bridge.ios(call => {
      call.callHandler('iOS Echo', {
        cmd: 'finishActivity',
      });
    });
  }

  function openInAppBrowser() {
    dabangBridge.ios(call => {
      call.callHandler('ObjC Echo', {
        cmd: 'openInAppBrowser',
        url: 'https://test-dabang-sign.dabangapp.com/mobile',
      });
    });

    bridge.android(call => {
      console.log('android');
      call.openInAppBrowser('https://test-dabang-sign.dabangapp.com/mobile');
    });
  }

  function proClose() {
    bridge.android(call => {
      call.finishActivity();
    });

    bridge.ios(call => {
      call.callHandler('iOS Echo', {
        cmd: 'finishActivity',
      });
    });
  }

  function proOpenBrowser() {
    const url = 'https://naver.com';

    bridge.android(call => {
      console.log('android');
      call.openBrowser(url);
    });

    bridge.ios(call => {
      call.callHandler('iOS Echo', {
        cmd: 'openBrowser',
        url: url,
      });
    });
  }

  function goSales() {
    const url = 'dabang://saleinlots/theme/30';

    bridge.android(call => {
      console.log('android');
      call.openBrowser(url);
    });

    dabangBridge.ios(call => {
      call.callHandler('ObjC Echo', {
        cmd: 'openBrowser',
        url: url,
      });
    });
  }

  function goSignRoomList(type) {
    let params = null;

    switch(type) {
      case 'bbox':
        params = {
          api_type: 'BBOX',
          location: JSON.stringify([[125.3723553,36.4041831],[129.9371747,37.4732536]]),
          zoom: 9,
        }
        break;

      case 'region':
        params = {
          api_type: 'REGION',
          id: '41210104',
          zoom: 14,
        };
        break;

      case 'subway':
        params = {
          api_type: 'SUBWAY',
          id: '124',
          zoom: 14,
        };
        break;

      case 'univ':
        params = {
          api_type: 'UNIV',
          id: '440',
          zoom: 14,
        };
        break;

      default:
        params = {};
    }

    console.log(JSON.stringify(params));

    bridge.android(call => {
      console.log('android');
      call.signRoomList(JSON.stringify(params));
    });

    dabangBridge.ios(call => {
      call.callHandler('ObjC Echo', {
        cmd: 'signRoomList',
        params: params,
      });
    });
  }

  function goSignRoomListRegion(id) {
    const params = {
      api_type: 'REGION',
      id,
      zoom: 14,
    };

    alert(JSON.stringify(params));

    bridge.android(call => {
      console.log('android');
      call.signRoomList(JSON.stringify(params));
    });

    dabangBridge.ios(call => {
      call.callHandler('ObjC Echo', {
        cmd: 'signRoomList',
        params: params,
      });
    });
  }

  return (
    <>
      <Wrap>
        <h1>[event_url]?auth_key=[auth_key]&platform=[platform]&version=[version]</h1>
        <br />
        <h1>auth_key : {authKey || '없음'}</h1>
        <h1>platform : {platform || '없음'}</h1>
        <h1>version : {appVersion || '없음'}</h1>
      </Wrap>

      <Wrap>
        <button onClick={() => checkWebkitWindow()}>iOS webkit window check</button>
        <button onClick={() => checkWebkit()}>iOS webkit check</button>
      </Wrap>

      <Wrap>
        <button onClick={() => goSignRoomListRegion('11680')}>전자계약 강남 (강남구)</button>
        <button onClick={() => goSignRoomListRegion('11620')}>전자계약 신림 (관악구)</button>
        <button onClick={() => goSignRoomListRegion('11')}>전자계약 홍대 (서울시)</button>
        <button onClick={() => goSignRoomListRegion('11560')}>전자계약 여의도 (영등포구)</button>
        <button onClick={() => goSignRoomListRegion('26')}>전자계약 해운대 (부산시)</button>
        <button onClick={() => goSignRoomList('bbox')}>전자계약 BBOX</button>
        <button onClick={() => goSignRoomList('region')}>전자계약 REGION</button>
        <button onClick={() => goSignRoomList('subway')}>전자계약 SUBWAY</button>
        <button onClick={() => goSignRoomList('univ')}>전자계약 UNIV</button>
      </Wrap>

      <Wrap>
        <button onClick={close}>다방 close</button>
        <button onClick={openBrowser}>다방 openBrowser</button>
        <button onClick={loginReload}>다방 로그인</button>
        <button onClick={authReload}>다방 본인인증</button>
        <button onClick={successSign}>다방 successSign</button>
        <button onClick={goSales}>다방 분양 테마</button>
      </Wrap>
      
      <Wrap>
        <button onClick={proClose}>프로 close</button>
        <button onClick={proOpenBrowser}>프로 openBrowser</button>
      </Wrap>

      <Wrap>
        <button onClick={openInAppBrowser}>다방 openInAppBrowser</button>
      </Wrap>

      <Wrap>
        <a href="tel:1899-6840">1899-6840</a>
        <a href="tel:18996840">18996840</a>
      </Wrap>

      <Wrap>
        <a href="https://test-dabang-sign.dabangapp.com/mobile">싸인 페이지</a>
      </Wrap>
    </>
  );
}

export default TestComponent;
